import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

interface MenuMaster {
  isDashboardDrawerOpened: boolean;
}

const initialState: MenuMaster = {
  isDashboardDrawerOpened: false
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR<MenuMaster>(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data ?? initialState,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: MenuMaster | undefined) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
